import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGridMakerConfig } from '@/data/landingConfig/landingGridMakerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GridMaker } from './schemaObject';

interface Props {}
const GridMaker: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GridMaker} />
			<LandingTemplate
				data={landingGridMakerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageSplitter()}
			/>
		</>
	);
};

export default GridMaker;
